import { render } from "./ratings.vue?vue&type=template&id=21de0524"
import script from "./ratings.vue?vue&type=script&lang=js"
export * from "./ratings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__